import React from "react";
import { useTranslation } from "react-i18next";
import GlobalAlert2 from "../../pages/home/GlobalAlert2";

// ── Props ────────────────────────────────────────────────────────────────────

export interface TimedActionAlertsProps {
  postOk: boolean;
  postErr: boolean;
  postError: unknown;
  putOk: boolean;
  putErr: boolean;
  putError: unknown;
  deleteOk: boolean;
  deleteErr: boolean;
  deleteError: unknown;
}

/**
 * The six near-identical GlobalAlert2 blocks (POST/PUT/DELETE × success/error)
 * that every scheduled-action container used to inline. Driven by the mutation
 * flags exposed by {@link useTimedActionsCrud}. Containers that never trigger a
 * given mutation (e.g. the delete-only org drawer) simply never flip the
 * corresponding flag, so those blocks stay dormant.
 */
function TimedActionAlerts({
  postOk,
  postErr,
  postError,
  putOk,
  putErr,
  putError,
  deleteOk,
  deleteErr,
  deleteError,
}: TimedActionAlertsProps): React.ReactElement {
  const [t] = useTranslation("global");
  const name = t("scheduledActions.action", "Scheduled Action");

  return (
    <>
      {postOk && (
        <GlobalAlert2 isSuccess requestType="POST" name={name} isError={false} error={undefined} />
      )}
      {postErr && (
        <GlobalAlert2 isError requestType="POST" name={name} isSuccess={false} error={postError} />
      )}
      {putOk && (
        <GlobalAlert2 isSuccess requestType="PUT" name={name} isError={false} error={undefined} />
      )}
      {putErr && (
        <GlobalAlert2 isError requestType="PUT" name={name} isSuccess={false} error={putError} />
      )}
      {deleteOk && (
        <GlobalAlert2
          isSuccess
          requestType="DELETE"
          name={name}
          isError={false}
          error={undefined}
        />
      )}
      {deleteErr && (
        <GlobalAlert2
          isError
          requestType="DELETE"
          name={name}
          isSuccess={false}
          error={deleteError}
        />
      )}
    </>
  );
}

export default TimedActionAlerts;
